export { default } from './visuallyHidden';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/visuallyHidden/index.js
// module id = 843
// module chunks = 25